<template>
    <div class="form">
        <h4 class="step-title">
            Is this your primary residence?
        </h4>
        <div class="step-content d-flex flex-column align-items-center">
            <scrollable-button-list v-bind:items="primaryResidenceTypes" v-bind:onclick="complete" v-bind:value="lead.homeInsurance.homeOccupancyType"/>
        </div>
    </div>
</template>

<script>
    import ScrollableButtonList from "../shared/ScrollableButtonList.vue"

    export default {
        name: "PrimaryResidence",
        components: {
            ScrollableButtonList
        },
        data: function() {
            return {
                primaryResidenceTypes: [
                    { text: "Yes", value: "PrimaryResidence" },
                    { text: "No", value: "SeasonalResidence" }
                ]
            }
        },
        props: {
            lead: Object
        },
        methods: {
            complete: function(value) {
                this.lead.homeInsurance.homeOccupancyType = value;
                this.$emit("complete", this.$options.name, value);
            }
        }
    }
</script>
